import { Theme } from '@mui/material';

type Transition = string | ((theme: Theme) => string);

export const mergeTransitions = (theme: Theme, ...transitions: Transition[]): string =>
  transitions
    .map(transition => (typeof transition === 'function' ? transition(theme) : transition))
    .filter(Boolean)
    .join(', ');
